import styled, { keyframes } from 'styled-components'
import Logo from '../../assests/images/LogoIcon.png'

const Spinner = ({ position }) => (
  <Container position={position}>
    <div className="loader_wrapper">
      <LoadingSpinner />
      <img src={Logo} alt="logo" />
    </div>
  </Container>
)

export default Spinner

const SpinnerAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

const LoadingSpinner = styled.div`
  width: 100%;
  height: 100%;
  border: 4px solid rgba(236, 236, 236, 0.5);
  border-top: 4px solid #f1bc11;
  border-radius: 50%;
  animation: ${SpinnerAnimation} 1.5s linear infinite;
`

const Container = styled.div`
  position: $;
  top: 0;
  left: 0;
  display: grid;
  justify-content: center;
  align-content: center;
  width: 100%;
  height: 100%;
  z-index: 999;
  position: ${({ position }) => position || 'absolute'};
  backdrop-filter: blur(5px);

  .loader_wrapper {
    width: 100px;
    height: 100px;
    position: relative;

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 60%;
      height: 60%;
    }
  }
`
